import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { AB_API_MOCK, CUSTOM_COOKIE_NAME } from '@/constants/experiment'
import { RootState } from '@/redux/store/configureStore'
import { setCustomExperimentCookie } from '@/utils/experiment'

import { IAbConfigInitialState } from './type'

const initialState: IAbConfigInitialState = {
    data: {},
    loading: false
}

export const fetchAbTestData = createAsyncThunk('abConfig/abTest', async () => {
    try {
        const response = AB_API_MOCK
        return response
    } catch (e) {
        return {}
    }
})

export const abConfigSlice = createSlice({
    name: 'abConfig',
    initialState,
    reducers: {
        setAbData: (state, action: PayloadAction<Record<string, string>>) => {
            const { payload } = action || {}
            state.data = (payload || {}) as Record<string, string>
        }
    },
    extraReducers(builder) {
        // TODO: Assign type to action instead of type alias
        builder.addCase(fetchAbTestData.fulfilled, (state, action) => {
            const { payload } = action || {}
            state.data = (payload || {}) as Record<string, string>
            state.loading = false
            for (const key of Object.keys(CUSTOM_COOKIE_NAME)) {
                setCustomExperimentCookie(key)
            }
        }),
            builder.addCase(fetchAbTestData.rejected, state => {
                state.data = {}
                state.loading = false
            })
    }
})

const getAbData = (state: RootState) => state.abConfig.data

/**
 * Returns a selector that resolves the current Statsig variant string for the
 * given experiment key (e.g. `'wow_price_ct'`). Mirrors the
 * `selectExperiment` helper from flights-pwa's statsigManager so callers can
 * write `useAppSelector(selectExperiment('wow_price_ct'))`.
 */
const selectExperiment = (experimentKey: string) => (state: RootState): string => {
    const data = state?.abConfig?.data || {}
    return (data?.[experimentKey] as string) || ''
}

const { reducer, actions } = abConfigSlice
const { setAbData } = actions || {}
export { getAbData, setAbData, selectExperiment }

export default reducer
